import { Link } from "wouter";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCookieConsent } from "./cookie-consent-provider";

export function FloatingContact() {
  const { showBanner } = useCookieConsent();
  
  return (
    <motion.div
      initial={false}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1, duration: 0.3, ease: "easeOut" }}
      className={`fixed right-4 bottom-6 z-40 lg:hidden ${showBanner ? "hidden" : ""}`}
    >
      <Button
        asChild
        size="icon"
        className="h-14 w-14 rounded-full shadow-lg shadow-primary/25 hover:shadow-xl hover:shadow-primary/35 transition-all duration-300"
        data-testid="button-floating-contact"
      >
        <Link href="/contatti">
          <MessageCircle className="h-6 w-6" />
          <span className="sr-only">Contattaci</span>
        </Link>
      </Button>
    </motion.div>
  );
}
